import { render, staticRenderFns } from "./confirmTransaction.vue?vue&type=template&id=385c7178&scoped=true"
import script from "./confirmTransaction.vue?vue&type=script&lang=js"
export * from "./confirmTransaction.vue?vue&type=script&lang=js"
import style0 from "./confirmTransaction.vue?vue&type=style&index=0&id=385c7178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c7178",
  null
  
)

export default component.exports